import { GetterTree } from 'vuex';
import { State } from './state';

import { RootState } from '@/modules/ewerp/store';
import { Maschine } from '@/modules/ewerp/models/MaschinenModels';

export type Getters = {
  maschinen(state: State): Array<Maschine>;
};

export const getters: GetterTree<State, RootState> & Getters = {
  maschinen(state) {
    return state.maschinen;
  },
};
